import { useParams } from 'react-router'
import { withAuth } from 'pages/ProtectedPage'
import { useMemo } from 'react'
import { API_URL } from 'config'
import { useSelector } from 'react-redux'
import { settingsSelectors } from 'store/settings'

export const AreaBlockPage = () => {
  const params = useParams<{ areaId: string; blockId: string }>()
  const blockId = params.blockId as string

  const token = useSelector(settingsSelectors.token)
  const url = useMemo(() => {
    const searchParams = new URLSearchParams({
      apiUrl: String(API_URL),
      token: String(token),
    })

    return `https://odin-editor.prod.aws.r-s.cloud/b/${blockId}/?${searchParams.toString()}`
  }, [blockId, token])

  return (
    <div
      style={{
        height: 'calc(100vh - 5rem)',
      }}
    >
      <iframe
        src={url}
        className="iframe"
        style={{ border: 'none', width: '100%', height: '100%' }}
        allow={'crossOrigin'}
        sandbox={'allow-same-origin allow-scripts allow-popups allow-forms'}
      />
    </div>
  )
}

export const AreaBlockPageProtected = withAuth(AreaBlockPage)
